import * as types from "../types";

import { Commit } from "vuex";

const state = {
  [types.SERVER_ERROR]: false,
  [types.SHOW_TRANSLATE]: false,
};
type State = typeof state;

const getters = {
  [types.SERVER_ERROR]: (state: State) => {
    return state[types.SERVER_ERROR];
  },
  [types.SHOW_TRANSLATE]: (state: State) => {
    return state[types.SHOW_TRANSLATE];
  },
  [types.APP_CLOSED]: () => {
    return new Date() > new Date(2023, 9, 5, 1, 0, 0);
  },
};

const mutations = {
  [types.MUTATE_SERVER_ERROR]: (state: State, payload: boolean) => {
    state[types.SERVER_ERROR] = payload;
  },
  [types.MUTATE_SHOW_TRANSLATE]: (state: State, payload: boolean) => {
    state[types.SHOW_TRANSLATE] = payload;
  },
};

const actions = {
  [types.SET_SERVER_ERROR]: (
    { commit }: { commit: Commit },
    payload: boolean
  ) => {
    commit(types.MUTATE_SERVER_ERROR, payload);
  },
  [types.SET_SHOW_TRANSLATE]: (
    { commit }: { commit: Commit },
    payload: boolean
  ) => {
    commit(types.MUTATE_SHOW_TRANSLATE, payload);
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
